import { AutogenModelEdiRefNumber, AutogenRowEdiRefNumber } from "./autogen/AutogenModelEdiRefNumber";

export class ModelEdiRefNumber extends AutogenModelEdiRefNumber<RowEdiRefNumber> {
    constructor() {
        super(RowEdiRefNumber);
    }
}

export class RowEdiRefNumber extends AutogenRowEdiRefNumber {
}